export const DRAWN_SIGNATURE = 'Drawn signature';
export const UPLOADED_SIGNATURE = 'Uploaded signature';
